<!-- <pre>
    {{tituladoForm.value|json}}
    {{tituladoForm.invalid}}
    
</pre>  -->

<header></header>
  
<div class="card mb-4">
    
    <div class="card-header">
        <h1 class="text-center text-secondary">ACTUALIZA TUS DATOS </h1>
    </div>
    <div class="p-3 mb-4"> 
        <div class="mb-5" >



            <form class="row" [formGroup]="rutForm" (ngSubmit)="buscarRut()"  *ngIf="!mostrarContenido">

                <div class="p-3" *ngIf="mensajeCorrecto">
                    <div class="alert alert-success alert-dismissible fade show" role="alert">
                        {{mensajeCorrecto}}
                    </div>
                </div>
                

                <div class="col-md-10">
                    <label  for="rut" class="form-label">RUT</label>
                    <input class="form-control"  type="text" formControlName="rut" (keyup)="checkRut()" />

                </div>
                <div class="col-md-2">
                    <label for="validationCustom02" class="form-label">&nbsp;</label>
                    <button [disabled]=" mensajeRut.length>0" class="btn btn-secondary form-control" type="button" (click)="buscarRut()"  >Buscar</button>
                    
                </div>
                
                <br/>
                <div class="col-12 text-center mt-2">
                    <span class="text-danger" >{{mensajeRut}}</span>
                </div>
            </form>

            <br/>
            <div *ngIf="botones" class="row mb-5">


                <div *ngIf="cuadroInforme"  class="row mb-4">
                    <div *ngIf="cuadroBoton" class="col-md-12 text-center"> 
                        <h2 class=" text-success">Posees un formulario actualizado </h2>
                        <p class="text-center">Se enviará un informe a tu correo con los datos</p>
                        <button (click)="enviarInforme()" type="button" class="btn btn-secondary  ">Enviar informe</button>

                    </div>
                    <div *ngIf="enviandoCorreo" class="col-12 text-center mt-2">
                        <span class="text-info" >Enviando correo ...</span>
                    </div>
                    <div *ngIf="mensajeCorreoBol" class="col-12 text-center mt-2">
                        <span class="text-success" >{{mensajeCorreo}}</span>
                    </div>
                 

                </div>
                <div *ngIf="cuadroActualiza" class="row">
                    
                    <div class="col-md-12 text-center">
                        <h3 class="">¿Deseas actualizar nuevamente tus datos?</h3>

                        <button (click)="mostrarContenidoForm()" type="button" class="btn btn-secondary ">Actualizar datos</button>
    
                    </div>
                    

                </div>
                

                

            </div>

            <form [formGroup]="tituladoForm" *ngIf="mostrarContenido">
                
                
                
                

                <div class="row mb-2" disabled="tituladoForm.invalid">
                    <div class="col-md-4">
                        <label for="rut" class="form-label">Nombre</label>
                        <input  class="form-control-plaintext h5"  formControlName="nombres" />
                        <hr/>

                    </div>
                    <div class="col-md-4">
                        <label for="validationCustom02" class="form-label">Apellido Paterno</label>
                        <input  class="form-control-plaintext h5" formControlName="paterno" />
                        <hr/>

                    </div>
                    <div class="col-md-4">
                        <label for="" class="form-label">Apellido Materno</label>
                        <input  class="form-control-plaintext h5"  formControlName="materno" />
                        <hr/>

                    </div>
                    
                </div>
                <div *ngIf="formulario" class="row mb-5">
                    
                    <div *ngIf="formulario.nom_carrera_1" class="card" >
                        <div class="card-body">
                            <label class="form-label" *ngIf="!formulario.nom_carrera_2">Tu carrera</label>

                            <label class="form-label" *ngIf="formulario.nom_carrera_2">Tus carreras</label>
                        </div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item h5">{{formulario.nom_carrera_1}}</li>
                            <li *ngIf="formulario.nom_carrera_2" class="list-group-item h5">{{formulario.nom_carrera_2}}</li>
                            <li *ngIf="formulario.nom_carrera_3" class="list-group-item h5">{{formulario.nom_carrera_3}}</li>
                        </ul>
                        
                    </div>





                </div>
                <div class="row mb-5">
                    

                    
                    <div class="col-md-4 mb-4">
                        <label for="" class="form-label">Género</label>
                        <select class="form-select" id="datalistOptions" formControlName="genero">
                            <option value="" disabled>----</option>
                            <option
                        
                                *ngFor="let genero of generos"
                                [ngValue]="genero.cod_genero"
                                >
                                {{genero.nom_genero}}
                            </option>

                        </select> 
                        <span class="text-danger ">{{validador('genero')}}</span>

                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col-md-4 mb-4">
                        <label for="validationCustomUsername" class="form-label">Correo Personal *</label>
                        <div class="input-group has-validation">
                            <span class="input-group-text" id="">@</span>
                            <input class="form-control" type="text"  formControlName="correo"  placeholder="nombre@ejemplo.cl"/>
            
                        </div>
                        <span class="text-danger ">{{validador('correo')}}</span>
                    </div>
                    <div class="col-md-4 mb-4">
                        <label for="validationCustom05" class="form-label">Teléfono Móvil *</label>
                        <div class="input-group">
                            <span class="input-group-text" id="">+569</span>

                            <input class="form-control" type="text"  formControlName="telefono_movil" placeholder="87654321"/>

                        </div>
                        
                        <span class="text-danger ">{{validador('telefono_movil')}}</span>

                    </div>
                    <div class="col-md-4 mb-4">
                        <label for="validationCustom05" class="form-label">Teléfono Fijo</label>
                        <div class="input-group">
                            <span class="input-group-text" id="">+562</span>

                            <input class="form-control" type="text" formControlName="telefono_fijo" placeholder="12345678"/>

                        </div>
                        <span class="text-danger ">{{validador('telefono_fijo')}}</span>


                    </div>
                   
                    
                    
                </div>

                <div class="row mb-5">
                    
                    <div class="col-md-4 mb-4">
                        
                        <label class="form-label" for="checked">
                        ¿Resides en otro país?
                        </label>
                        <select class="form-select" id="checked" formControlName="reside_otro_pais">
                            <option value="" disabled>----</option>
                            <option value=true >Si</option>
                            <option value=false >No</option>
            
        
                        </select> 
                        <span class="text-danger ">{{validador('reside_otro_pais')}}</span>

                    </div>
                    <div *ngIf="mostrarPaises" class="col-md-4 mb-4">
                        <label for="exampleDataList" class="form-label">Selecciona Pais de Residencia</label>
                        <select class="form-select" id="datalistOptions" formControlName="pais_domicilio_extranjero">
                            <option value="" disabled>----</option>
                            <option
                        
                                *ngFor="let pais of paises"
                                [ngValue]="pais.id"
                                >
                                {{pais.nom_pais}}
                            </option>
        
                        </select> 
                        <span class="text-danger ">{{validador('pais_domicilio_extranjero')}}</span>


                    </div>
                    
                    
                    
                    
                    
                
                </div>
                
                <div class="row mb-5">
                    <div class="col-md-8 mb-4">
                        <label for="" class="form-label">Domicilio</label>
                        <input class="form-control" type="text"  formControlName="direccion" placeholder="Condell ..." />
                        <span class="text-danger ">{{validador('direccion')}}</span>
                    </div>
                    <div class="col-md-4 mb-4">
                        <label for="" class="form-label">Numeración del Domicilio</label>
                        <input class="form-control" type="text"  formControlName="numeracion" placeholder="343" />
                        <span class="text-danger ">{{validador('numeracion')}}</span>
                    </div>
                    
                    

                   
                </div>
                <div class="row mb-5">
                    <div class="col-md-4 mb-4">
                        <label for="" class="form-label">Depto/Casa/Sitio/Otro </label>
                        <input class="form-control" type="text"  formControlName="otro_domicilio" placeholder="Depto 12 ..." />
                        <span class="text-danger ">{{validador('otro_domicilio')}}</span>
                    </div>
               
                    

                   
                </div>
         

                <div *ngIf="mostrarComunaDomicilio" class="row mb-5">
                   
                    <div  class="col-md-8 mb-4">
                        <label for="" class="form-label">Comuna del Domicilio</label>
                        <select class="form-select" id="datalistOptions" formControlName="comuna">
                            <option value="" disabled>----</option>
                            <option
                        
                                *ngFor="let comuna of comunas"
                                [ngValue]="comuna.id"
                                >
                                {{comuna.nom_comuna}}
                            </option>

                        </select> 
                        <span class="text-danger ">{{validador('comuna')}}</span>

                    </div>
                    

                   
                </div>
                
                
              
                

                

                <br/>
                <div class="row mb-5">
                    <div class="col-md-8">
                        
                        <label class="form-label" for="checked">
                        ¿Estás trabajando actualmente?
                        </label>
                        <select class="form-select" id="checked" formControlName="trabajas">
                            <option value="" disabled>----</option>
                            <option value=true >Si</option>
                            <option value=false >No</option>
            
        
                        </select> 
                        <span class="text-danger ">{{validador('trabajas')}}</span>

                    </div>
                </div>
                <br/>
                <div *ngIf="mostrarEmpresa">
                    <div class="row mb-5">


                        <div class="col-md-8 mb-4">
                            
                            
                            <label class="form-label" for="btn-checked">
                            ¿Consideras que tu empleo se relaciona con lo que estudiaste?
                            </label>
                            <select class="form-select" id="datalistOptions" formControlName="empleo_relacion_carrera">
                                <option value="" disabled>----</option>
                                <option value=true >Si</option>
                                <option value=false >No</option>
                
            
                            </select> 
                            <span class="text-danger ">{{validador('empleo_relacion_carrera')}}</span>

                        </div>
              
                    </div>
                    <div class="row mb-5">


                        
                        <div class="col-md-8 mb-4">
                            <label for="validationCustomUsername" class="form-label">Ingresa tu correo Institucional o Laboral</label>
                            <div class="input-group has-validation">
                                <span class="input-group-text" id="">@</span>
                                <input class="form-control" type="text"  formControlName="correo_institucional" placeholder="nombre@academia.cl"/>
    
                            </div>
                            <span class="text-danger ">{{validador('correo_institucional')}}</span>
    
                        </div>
                    </div>
                    <div class="row mb-5">
                        <div class="col-md-8 mb-4">
                            <label for="empresa" class="form-label">Empresa</label>
                            <input class="form-control" type="text"  formControlName="empresa" [placeholder]="" />
                            <span class="text-danger ">{{validador('empresa')}}</span>

            
                        </div>
                        <div class="col-md-4 mb-4">
                            <label for="labor" class="form-label">Cargo</label>
                            <input class="form-control" type="text"  formControlName="cargo" />
                            <span class="text-danger ">{{validador('cargo')}}</span>

            
                        </div>
                    </div>
            
                    <div class="row mb-5">
                        <div class="col-md-8 mb-4">
                            <label for="validationCustom03" class="form-label">Dirección Laboral</label>
                            <input class="form-control" type="text"  formControlName="direccion_empresa" placeholder="Av Condell ..."/>
                            <span class="text-danger ">{{validador('direccion_empresa')}}</span>

                            
                        </div>
                        <div class="col-md-4 mb-4">
                            <label for="" class="form-label">Numeración Laboral</label>
                            <input class="form-control" type="text"  formControlName="numeracion_empresa" placeholder="343" />
                            <span class="text-danger ">{{validador('numeracion_empresa')}}</span>
                        </div>
                     
                    </div>
                    <div class="row mb-5">
                        <div class="col-md-4 mb-4">
                            <label for="" class="form-label">Depto/Casa/Sitio/Otro </label>
                            <input class="form-control" type="text"  formControlName="otro_laboral" placeholder="Casa 2 ..." />
                            <span class="text-danger ">{{validador('otro_laboral')}}</span>
                        </div>
                   
                        
    
                       
                    </div>
                    <div class="row mb-5">
                        
                        <div class="col-md-8 mb-4">
                            <label for="exampleDataList" class="form-label">Comuna Laboral</label>
                            <select class="form-select" id="datalistOptions" formControlName="comuna_empresa">
                                <option value="" disabled>----</option>
                                <option
                            
                                    *ngFor="let comuna of comunas"
                                    [ngValue]="comuna.id"
                                    >
                                    {{comuna.nom_comuna}}
                                </option>
            
                            </select> 
                            <span class="text-danger ">{{validador('comuna_empresa')}}</span>

                        </div>
                    </div>
                    <div class="row mb-5">
                        <div class="col-md-8 mb-4">
                            <label for="empresa" class="form-label">Señala el nombre de tu empleador/a</label>
                            <input placeholder="Considera como empleador a tu jefatura directa" class="form-control" type="text"  formControlName="empleador_nombre" [placeholder]="" />
                            <span class="text-danger ">{{validador('empleador_nombre')}}</span>


            
                        </div>
                        <div class="col-md-4 mb-4">
                            <label for="validationCustom05" class="form-label">Teléfono de tu empleador</label>
                            <div class="input-group">
                                <span class="input-group-text" id="">+56</span>
            
                                <input class="form-control" type="text" formControlName="empleador_telefono" placeholder="2 12345678 / 9 12345678"/>
            
                            </div>
                            <span class="text-danger ">{{validador('empleador_telefono')}}</span>
            
            
                        </div>
                        
                        
                    </div>
                    <div class="row mb-5">
                        
                        <div class="col-md-8 mb-4">
                            <label for="validationCustomUsername" class="form-label">Correo Empleador</label>
                            <div class="input-group has-validation">
                                <span class="input-group-text" id="">@</span>
                                <input class="form-control" type="text"  formControlName="empleador_correo" placeholder="empleador@empresa.cl"/>
            
                            </div>
                            <span class="text-danger ">{{validador('empleador_correo')}}</span>
            
                        </div>
                        <div class="col-md-4">
                            <label for="exampleDataList" class="form-label">Tipo de relación contractual</label>
                            <select class="form-select" id="datalistOptions" formControlName="contrato_tipo">
                                <option value="" disabled>----</option>
                                <option
                            
                                    *ngFor="let contrato of contratosTipo"
                                    [ngValue]="contrato.id"
                                    >
                                    {{contrato.nom_contrato_tipo}}
                                </option>
            
                            </select> 
                            <span class="text-danger ">{{validador('contrato_tipo')}}</span>

                        </div>
                        
                        
                    </div>

                </div>
                
                <div *ngIf="!mostrarEmpresa">
                    <hr/>
                    
                    <div class="row mb-5 mt-5">


                        <div class="col-md-8 mb-4">
                            <label for="validationCustom03" class="form-label">¿Hace cuánto tiempo estás sin trabajo?</label>

                        
                            <select class="form-select" id="datalistOptions" formControlName="tiempo_sin_trabajo" >
                                <option value="" disabled>----</option>
                                <option
                            
                                    *ngFor="let tiempo_sin of tiempo_sin_trabajos"
                                    [ngValue]="tiempo_sin.id"
                                    >
                                    {{tiempo_sin.nom_sin_trabajo}}
                                </option>
            
                            </select> 
                            <span class="text-danger ">{{validador('tiempo_sin_trabajo')}}</span>

                        </div>

                        
                    </div>
                    <div class="row mb-5 mt-5">



                        <div class="col-md-8 mb-4">
                            
                            <label class="form-label" for="checked">
                                ¿Te gustaría recibir ofertas de empleo a tu correo?
                            </label>
                            <select class="form-select" id="checked" formControlName="ofertas_empleo">
                                <option value="" disabled>----</option>
                                <option value=true >Si</option>
                                <option value=false >No</option>
                
            
                            </select> 
                            <span class="text-danger ">{{validador('ofertas_empleo')}}</span>

                        </div>
                        
                    </div>
                    
                  
                    <div *ngIf="ofertasEmpleo">
                        <div class="row mb-5" >
                            <div class="col-md-8" formArrayName="ambito_laboral">
                                <label for="exampleDataList" class="form-label mb-4">¿En qué ámbito te gustaría recibir ofertas?</label>
                                <br/>

                                <div class="form-check mb-2" *ngFor="let ambito of ambitoLaboral.controls ;let i = index" >
                                    <input class="form-check-input " type="checkbox" value="" id="{{ambito.value.nombre}}" (click)="seleccciorAmbito(i)">
                                    <label class="form-check-label " style="font-size: 20px;" for="{{ambito.value.nombre}}" >
                                    {{ambito.value.nombre}}
                                    </label>
                                </div>

                                


                            </div>
                            <!-- <div class="col-md-8">
                                <label for="exampleDataList" class="form-label">¿Cada cuánto tiempo te gustaría recibir las ofertas?</label>
                                <select class="form-select" id="datalistOptions" formControlName="tiempo_ofertas">
                                    <option value="" disabled>----</option>
                                    <option
                                
                                        *ngFor="let tiempo of tiempo_ofertas"
                                        [ngValue]="tiempo.id"
                                        >
                                        {{tiempo.nom_tiempo}}
                                    </option>
                
                                </select> 
                            </div> -->
                            
                            
                        </div>

                        <div class="row mb-5">
                            <div class="col-md-8">
                                <label for="exampleDataList" class="form-label">¿Cada cuánto tiempo te gustaría recibir las ofertas?</label>
                                <select class="form-select" id="datalistOptions" formControlName="tiempo_ofertas">
                                    <option value="" disabled>----</option>
                                    <option
                                
                                        *ngFor="let tiempo of tiempo_ofertas"
                                        [ngValue]="tiempo.id"
                                        >
                                        {{tiempo.nom_tiempo}}
                                    </option>
                
                                </select> 
                                <span class="text-danger ">{{validador('tiempo_ofertas')}}</span>

                            </div>
                            
                            
                        </div>
                        <div class="row mb-5">
                            <!-- <div class="col-12">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="assitir"  formControlName="taller_empleabilidad">
                                    <label class="form-label" for="assitir">
                                    ¿Asistirías a talleres de empleabilidad?
                                    </label>
                                </div>
                            </div> -->

                            <div class="col-md-8 mb-4">
                            
                            
                                <label class="form-label" for="btn-checked">
                                    ¿Asistirías a talleres de empleabilidad?
                                </label>
                                <select class="form-select" id="datalistOptions" formControlName="taller_empleabilidad">
                                    <option value="" disabled>----</option>
                                    <option value=true >Si</option>
                                    <option value=false >No</option>
                    
                
                                </select> 
                                <span class="text-danger ">{{validador('taller_empleabilidad')}}</span>

                            </div>


                        </div>
                        <div class="row mb-5">
                            <div class="col-12">
                                <label class="form-label" for="btn-checked">
                                    Sugerencias para fortalecer la empleabilidad
                                </label>
                                <div class="input-group">
                                    <textarea 
                                    class="form-control" 
                                    aria-label="With textarea"
                                    formControlName="comentarios"
                                    ></textarea>
                                </div>
                                <span class="text-danger ">{{validador('comentarios')}}</span>

                            </div>
                        </div>

                    </div>
                    
                    

                </div>

            

                <br>
            
                <div class="d-flex justify-content-center mt-4 text-center row">
                    <span class="col-12 mb-4 text-danger" [innerHTML]="mensajeError"  ></span>
                    <div class="col-12 ">
                        <button class="btn btn-secondary btn-lg" type="button" (click)="guardarFormulario()">Enviar Formulario</button>
                    </div>
                </div>
            

            </form>
            
            
        </div>
    </div>
</div>




<!--
<hr/>

                    <table *ngIf="formulario.nom_carrera_1" class="table table-responsive table-striped                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     ">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Nombre Carrera</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">1</th>
                            <td></td>
                          </tr>
                          <tr *ngIf="formulario.nom_carrera_2">
                            <th scope="row">2</th>
                            <td></td>
                          </tr>
                          <tr *ngIf="formulario.nom_carrera_3">
                            <th  scope="row">3</th>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>


-->


                    <!-- yyyy-mm-dd h:mm -->
